export default __webpack_public_path__ + "static/media/calculateLight.7de848c0.svg";